import {
  AuthChangeEvent,
  SupabaseClient
} from "@supabase/supabase-js";
import { loggerService } from "./logger-service";
import { ROUTES } from "@/core/router/routes";
import { _supabaseClient } from "./supabase/supabase-instance";

export class SupabaseService {
  private supabase: SupabaseClient;

  constructor() {
    this.supabase = _supabaseClient;
  }

  async onAuthStateChange(
    callback: (event: AuthChangeEvent, session: any) => void
  ) {
    return this.supabase.auth.onAuthStateChange((event, session) => {
      callback(event, session);
    });
  }

  async signWithGoogle() {
    const redirectTo = `${window.location.origin}/${ROUTES.Auth.Root}/${ROUTES.Auth.OAuthCallback}`;
    const response = await this.supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: redirectTo
      }
    });
    return response;
  }



  async signUpWithMicrosoft() {
    const response = await this.supabase.auth.signInWithOAuth({
      provider: "azure"
    });
    return response;
  }

  async signUpWithEmail(email: string) {
    try {
      const { data, error } = await this.supabase.auth.signInWithOtp({
        email,
        options: {
          shouldCreateUser: false,
          emailRedirectTo: `${window.location.origin}/auth/verify-email`
        }
      });

      if (error) {
        const statusCode = error.status;
        const errorMessage = error.message;
        loggerService.log("error", { statusCode, message: errorMessage });
        throw { statusCode, message: errorMessage };
      }

      return { statusCode: 200, data };
    } catch (err) {
      loggerService.log("err", err);
      throw err;
    }
  }

  async signInWithEmail(email: string) {
    const { data, error } = await this.supabase.auth.signInWithOtp({
      email,
      options: {
        shouldCreateUser: false,
        emailRedirectTo: `${window.location.origin}/auth/verify-email`
      }
    });
    loggerService.log("data", data);
    if (error) throw error;
    return data;
  }

  async getSession() {
    const { data, error } = await this.supabase.auth.getSession();
    if (error) throw error;
    return data;
  }

  async getCurrentUser() {
    const {
      data: { user },
      error
    } = await this.supabase.auth.getUser();
    if (error) throw error;
    return user;
  }

  async signOut() {
    await this.supabase.auth.signOut();
  }
}

export const supabaseService = new SupabaseService();
